import { Link ,useLocation } from "react-router-dom";
import classes from "./MainNavigation.module.css";
import { auth } from "../../firebaseConfig";
import { signOut } from "firebase/auth";
import { useState } from "react";
import appIcon from "../../assets/appiconweb.png"; // 👈 put your app icon in /src/assets/icon.png or update path

const MainNavigation = ({ user }) => {
    const location = useLocation();
      const isDailyWeb = location.pathname === "/dailyweb";
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  const handleLogout = async () => {
    try {
      await signOut(auth);
    } catch (err) {
      console.error("Logout failed:", err);
    }
  };

  return (
    <header className={classes.header}>
      <Link className={classes.site_title} to="/">
        <img 
          src={appIcon}  // 👈 put your app icon in /public/icon.png or update path
          alt="dothink logo"
          className={classes.site_icon}
          style={{ width: '16px', height: '16px', marginRight: '8px' }}
        />
        dothink
      </Link>

      <nav className={classes.site_nav}>
        <ul>

          {/* <li>
            <Link className={classes.profile_link} style={{backgroundColor: "lightgreen"}} to="https://myembeddedsystems.com/" target="_blank">
              <span>MyEmbeddedSystems</span>
            </Link>
          </li> */}

          <li>
            <Link className={`${classes.rainbow_link} ${isDailyWeb ? classes.muted : ""}`} to="/dailyweb">
              <span>The Daily Web</span>
            </Link>
          </li>

          <li>
            <Link className={classes.profile_link} style={{backgroundColor: "darkblue", color: "white"}} to="/daily-web-history">
              <span>History of the Web</span>
            </Link>
          </li>

          <li>
            <Link className={classes.profile_link} style={{backgroundColor: "cyan", color: "black"}}  to="/explore">
              <span style={{color: "black"}}>Explore</span>
            </Link>
          </li>

          {/* <li>
            <Link className={classes.profile_link} to="/ideamap">
              <span>Today</span>
            </Link>
          </li> */}

          {/* Dropdown Menu */}
          <li className={classes.dropdown}>
            <button
              className={classes.dropdown_toggle}
              onClick={() => setIsDropdownOpen((prev) => !prev)}
            >
              More ▾
            </button>
            <ul
              className={`${classes.dropdown_menu} ${
                isDropdownOpen ? classes.open : ""
              }`}
            >
              <li><Link to="/info" onClick={() => setIsDropdownOpen(false)}>About</Link></li>
              <li><Link to="/contact" onClick={() => setIsDropdownOpen(false)}>Contact Us</Link></li>
              <li><Link to="/privacy" onClick={() => setIsDropdownOpen(false)}>Privacy Policy</Link></li>
              <li><Link to="/terms" onClick={() => setIsDropdownOpen(false)}>Terms & Conditions</Link></li>
            </ul>
          </li>


          {user && (
            <>
              <li>
                <Link className={classes.profile_link} to="/account">
                  <span>Account</span>
                </Link>
              </li>
              <li>
                <button
                  className={classes.logout_button}
                  onClick={handleLogout}
                >
                  Logout
                </button>
              </li>
            </>
          )}

          {!user && (
            <li>
              <Link className={classes.login_link} to="/login" state={{ defaultMode: "login" }} >
                Login
              </Link>
            </li>
          )}
        </ul>
      </nav>
    </header>
  );
};

export default MainNavigation;
